export default __webpack_public_path__ + "de3656a538d9ec8374d79da0c1b40ebc.png";